<template>
    <div class="main-wrapper scroll-y custom-scrollbar view-asm-first-login">

        <page-title :title="'Pierwsze logowanie ASM'" :back="false"></page-title>

        <slide-y-up-transition :duration="500" :delay="200">
            <div v-show="show" class="box-info text-center">To Twoje pierwsze logowanie jako ASM, musisz ustalić hasło
                i wyrazić zgody, aby móc dalej korzystać z aplikacji.
            </div>
        </slide-y-up-transition>

        <form-asm-first-login></form-asm-first-login>

    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import PageTitle from '@/components/PageTitle.vue';
    import FormAsmFirstLogin from '@/forms/FormAsmFirstLogin.vue';

    export default {
        name: 'AsmFirstLogin',
        components: { PageTitle, FormAsmFirstLogin },
        computed: {
            ...mapState({
                loading: state => state.auth.loading,
                errors: state => state.auth.errors,
            })
        },
        data() {
            return {
                show: false
            }
        },
        mounted() {
            this.$store.commit('profile/PROFILE_SET_HEADER_DISABLED', true);
            this.show = true;
        },
    }
</script>

<style lang="scss" scoped>
    .view-asm-first-login {
        background: white;
    }
</style>